import { render, staticRenderFns } from "./ManagePlan.vue?vue&type=template&id=0439b038&scoped=true"
import script from "./ManagePlan.vue?vue&type=script&lang=js"
export * from "./ManagePlan.vue?vue&type=script&lang=js"
import style0 from "./ManagePlan.vue?vue&type=style&index=0&id=0439b038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0439b038",
  null
  
)

export default component.exports